import { GridLogicOperator } from '@mui/x-data-grid-pro';
import { MenuItem, Select, useTheme } from '@mui/material';
import { setQuickFilterLogicOperator } from '@/Infrastructure/applicationSlice';
import { useAppDispatch, useAppSelector } from '@reduxStore';

import styles from './Dispatch/DataGrid.Dispatch.module.css';

export default function QuickFilterOperatorDropdown(props: { className?: string }) {
  const dispatch = useAppDispatch();
  const { quickFilterLogicOperator } = useAppSelector((state) => state.applicationState);
  const theme = useTheme();

  return (
    <Select
      className={`${styles['quick-filter-operator']} ${props.className ?? ''}`}
      value={quickFilterLogicOperator}
      onChange={(e) => dispatch(setQuickFilterLogicOperator(e.target.value))}
      size='small'
      variant='outlined'
      sx={{
        color: theme.palette.text.secondary
      }}
      title="Controls how multiple search terms are combined. 'And' shows rows matching all terms. 'Or' shows rows matching any term.">
      <MenuItem value={GridLogicOperator.And}>And</MenuItem>
      <MenuItem value={GridLogicOperator.Or}>Or</MenuItem>
    </Select>
  );
}
